// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

// Components
import { Icon, Radio } from 'opencare-crown';
import {
  Container,
  FlexRow,
  FlexStatic,
  Span,
} from 'common/styles/oc-styled-components';

import {
  colors,
  NAV_HEIGHT,
  FONT_FAMILIES,
} from 'common/styles/style-constants';

import {
  useWindowDimensions,
  DIMENSIONS,
} from 'providers/WindowDimensionsProvider';

import scrollToRef from 'utils/scrollToRef';

import { useOfferService } from 'services/OfferService';

import {
  ResultsTabStateHandler,
  RESULTS_TAB,
} from 'connect/state/handlers/results';

import OpencareLogoSvg from '../svgs/OpencareLogoSvg';
import OfferBanner from '../OfferBanner/OfferBanner';
import HelpButton from '../HelpButton/HelpButton';

// Other

import {
  selectDataMatchId,
  selectDataUser,
} from '../../../../connect/selectors';
import CONFIG from '../../../../../app.config';

import { PARTNER_PATH, RESULTS_PATH } from '../../../../containers/App/Routes';

import {
  RadioIcon,
  MatchesLink,
  SkipToContentButton,
} from './styled-components';

// Component
const HeaderBar = ({
  pageName,
  refToBookingWidget,
  refToMainContent,
  hideTabs,
}) => {
  const dispatch = useDispatch();

  const offerService = useOfferService();
  const { layout } = useWindowDimensions();

  const tab = useSelector(ResultsTabStateHandler.selector);
  const user = useSelector(selectDataUser);
  const matchId = useSelector(selectDataMatchId);

  const logoWithText = layout !== DIMENSIONS.MOBILE;
  const showTabs =
    !hideTabs && (layout === DIMENSIONS.MOBILE || layout === DIMENSIONS.TABLET);
  const returnLink = _.get(user, 'partner') ? PARTNER_PATH : RESULTS_PATH;

  const handleTabChange = e => {
    dispatch(ResultsTabStateHandler.update(e.target.value));
  };

  return (
    <>
      {offerService.hasActiveOffer 
        && (
          <OfferBanner
            offerName={offerService.offerName}
            isThirdPartyOffer={offerService.isThirdPartyOffer}
          />
        )
      }
      <Container
        align="center"
        height={layout === DIMENSIONS.MOBILE ? '60px' : '80px'}
        padding={layout === DIMENSIONS.MOBILE ? '0 15px' : ''}
        position="relative"
      >
        <a aria-label="Opencare homepage" href={CONFIG.SEARCH_APP_URL}>
          <OpencareLogoSvg height="30px" withText={logoWithText} />
        </a>
        {pageName === 'profile' && refToBookingWidget 
          && (
            <SkipToContentButton onClick={() => scrollToRef(refToBookingWidget)}>
              Skip to appointment booking widget
            </SkipToContentButton>
          )
        }

        {refToMainContent 
          && (
            <SkipToContentButton
              onClick={() => scrollToRef(refToMainContent, NAV_HEIGHT + 10)}
            >
              Skip to main content
            </SkipToContentButton>
          )
        }

        {showTabs && pageName === 'list'
          ?           (
            <FlexStatic margin="0 0 0 auto">
              <Radio.Group value={tab} onChange={handleTabChange}>
                <Radio.Button value={RESULTS_TAB.LIST}>
                  <RadioIcon type="menu" aria-hidden />
                  {layout === DIMENSIONS.MOBILE ? 'List' : 'List View'}
                </Radio.Button>
                <Radio.Button value={RESULTS_TAB.MAP}>
                  <RadioIcon type="global" aria-hidden />
                  {layout === DIMENSIONS.MOBILE ? 'Map' : 'Map View'}
                </Radio.Button>
              </Radio.Group>
            </FlexStatic>
          )
          : null}
        {matchId && pageName === 'profile' 
          && (
            <MatchesLink
              to={returnLink}
              aria-label="Return to match results list"
            >
              <FlexRow align="center">
                <Icon type="unordered-list" style={{ color: colors.ash }} />
                <Span
                  color={colors.gray7}
                  fontSize="14px"
                  margin="0 0 0 10px"
                  fontFamily={FONT_FAMILIES.circular}
                >
                  {layout === DIMENSIONS.MOBILE
                    ? 'View all'
                    : 'Return to matches'}
                </Span>
              </FlexRow>
            </MatchesLink>
          )
        }
        <FlexStatic margin={pageName === 'list' ? '0 0 0 auto' : '0'}>
          <HelpButton
            slim="true"
            margin={pageName === 'list' ? '0' : '0 0 0 20px'}
          />
        </FlexStatic>
      </Container>
    </>
  );
};

HeaderBar.propTypes = {
  pageName: PropTypes.string,
  refToBookingWidget: PropTypes.object,
  refToMainContent: PropTypes.object,
  hideTabs: PropTypes.bool,
};

export default HeaderBar;
